import React from 'react';
import { Box, Text, Heading } from '@chakra-ui/react';

const TestOnboarding = () => {
  return (
    <Box p={8}>
      <Heading>Test Onboarding Component</Heading>
      <Text>This is a simple test to see if the component loads.</Text>
    </Box>
  );
};

export default TestOnboarding;
